import { UNCATEGORIZED_CATEGORY } from "src/main/ManageItems/utils/uncategorized"

import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

// The "uncategorized" sentinel must reach the backend as an empty value so the
// query matches product_category_id IS NULL. buildQueryString stringifies null
// as "null", so map the sentinel to "" explicitly.
const withProcessedCategories = (params) =>
  params.productCategories
    ? {
        ...params,
        productCategories: params.productCategories.map((id) =>
          id === UNCATEGORIZED_CATEGORY.id ? "" : id
        ),
      }
    : params

export const getProductsTable = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(withProcessedCategories(params))

  return queryApi(`/manage/${marinaSlug}/products_table${qs}`)
}

export const getProductsTableIds = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(withProcessedCategories(params))

  return queryApi(`/manage/${marinaSlug}/products_table/selectable_ids${qs}`)
}

export const bulkUpdateProductsStatus = ({ ids, status }) => {
  const marinaSlug = getCurrentMarinaSlug()

  return mutateApi({
    url: `/manage/${marinaSlug}/products_table/bulk_status`,
    method: "PATCH",
    data: { ids, status },
  })
}
